export default {
  title: "L'importazione è in corso... 🙂",
  description: "Le notifiche Slack verranno inviate al termine dell'importazione.",
  buttons: {
    open_followers_list: 'Apri lista follower',
  },
};
